import {
  FormControlLabel,
  FormGroup,
  Switch,
  SwitchProps,
  styled,
} from "@mui/material";
import * as React from "react";
import { Form } from "react-bootstrap";

declare const window: any;

export default function SettingsContainer({
  colors,
  theme,
  setIsTheme,
  menuSelected,
  setIsCotizacion,
  setShow,
  show,
  setShowTextHotspots,
  showTextHotspots,
  animationIntro,
  isPortrait,
  version,
  languages,
  
  selectedLanguage,
  setSelectedLanguage,
  multiLanguage,
  setMultiLanguage,
}: any) {
  React.useEffect(() => {
    const setting_botton: any = document.querySelector(
      ".setting-boton-circular"
    );
    const setting_dropdown: any = document.querySelector(".setting-dropdown");
    if (show !== "") {
      if (setting_botton) {
        setting_botton.style.backgroundColor = colors?.main_buttons;
        setting_dropdown.style.display = "block";
      }
    } else {
      if (setting_botton) {
        setTimeout(() => {
          if (setting_dropdown) {
            setting_dropdown.style.display = "none";
          }
        }, 1000);
        if (theme === "Glass") {
          setting_botton.style.backgroundColor = "rgba(150, 150, 150, 0.6)";
          setting_botton.style.backdropFilter = "blur(10px) contrast(120%)";
          setting_botton.style.boxShadow =
            "0 0 0.625rem 0.2rem rgba(0, 0, 0, 0.2)";
          setting_botton.style.color = "#fff";
        } else if (theme === "Light") {
          setting_botton.style.backgroundColor = "rgba(255, 255, 255, 1)";
          setting_botton.style.color = "#212427";
        } else if (theme === "Dark") {
          setting_botton.style.backgroundColor = "#212427";
          setting_botton.style.color = "#fff";
        }
      }
    }
  }, [show]);

  const IOSSwitch = styled((props: SwitchProps) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width:
      !window.functionIsPortrait() && window.functionIsMobileDevice() ? 20 : 36,
    height:
      !window.functionIsPortrait() && window.functionIsMobileDevice() ? 10 : 20,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin:
        !window.functionIsPortrait() && window.functionIsMobileDevice() ? 1 : 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform:
          !window.functionIsPortrait() && window.functionIsMobileDevice()
            ? "translateX(10px)"
            : "translateX(16px)",
        color: colors?.main_buttons,
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#D6D6D6",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: `6px solid ${colors?.main_buttons}`,
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width:
        !window.functionIsPortrait() && window.functionIsMobileDevice()
          ? 8
          : 16,
      height:
        !window.functionIsPortrait() && window.functionIsMobileDevice()
          ? 8
          : 16,
    },
    "& .MuiSwitch-track": {
      borderRadius: 20 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  const ref: any = React.useRef();

  React.useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        //console.log("Clicked outside!");
        setShow("");
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  

  return (
    <div className={`setting-container`} ref={ref}>
      <div
        className={`setting-boton-circular ${animationIntro ? "show" : ""}`}
        onClick={() => {
          setShow(show !== "" ? "" : "show");
          setIsCotizacion(false);
        }}
      >
        <i className="fas fa-ellipsis"></i>
      </div>
      <div className={`setting-dropdown ${show} ${theme} ${menuSelected}`}>
        <div className="setting-dropdown-theme">
          <span> {selectedLanguage?.is_main
                                  ? "Estilo de interfaz"
                                  : selectedLanguage?.language_code === "en" ? "Interface style" : "Estilo de interfaz"}</span>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              width:
                !isPortrait && window.functionIsMobileDevice()
                  ? "8.125rem"
                  : "12.375rem",
            }}
          >
            <div className="setting-dropdown-theme-only">
              <div
                style={{
                  backgroundColor:
                    theme === "Glass"
                      ? colors?.main_buttons
                      : "rgba(0, 0, 0, 0.4)",
                }}
                onClick={() => setIsTheme("Glass")}
              >
                <i className="fas fa-clone"></i>
              </div>
              {theme === "Glass" ? theme : null}
            </div>
            <div className="setting-dropdown-theme-only">
              <div
                style={{
                  backgroundColor:
                    theme === "Light"
                      ? colors?.main_buttons
                      : "rgba(0, 0, 0, 0.4)",
                }}
                onClick={() => setIsTheme("Light")}
              >
                <i className="fas fa-sun"></i>
              </div>
              {theme === "Light" ? theme : null}
            </div>
            <div className="setting-dropdown-theme-only">
              <div
                style={{
                  backgroundColor:
                    theme === "Dark"
                      ? colors?.main_buttons
                      : "rgba(0, 0, 0, 0.4)",
                }}
                onClick={() => setIsTheme("Dark")}
              >
                <i className="fas fa-moon"></i>
              </div>
              {theme === "Dark" ? theme : null}
            </div>
          </div>
        </div>
        {multiLanguage && 
          languages.map((lang: any) => (
            <div className="setting-dropdown-theme small">
              {lang?.name}
              <>
                <style>
                  {`
        #custom-switch.form-check-input:checked {
          background-color: ${colors?.main_buttons} !important;
          border-color: ${colors?.main_buttons} !important;
        }
      `}
                </style>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  checked={selectedLanguage?.language_code === lang.language_code}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setSelectedLanguage(lang)
                  }
                />
              </>
            </div>
          ))}

        {/* <div
          className="setting-dropdown-theme small"
          style={{ textAlign: "left", 
          pointerEvents: "none",
          opacity: "0.5",
          cursor: "none" }}
        >
          <i className="fas fa-language" style={{ marginRight: "0.4rem", 
          pointerEvents: "none",
          opacity: "0.5",
          cursor: "none" }}></i>
          English
        </div>
        <div
          className="setting-dropdown-theme small"
          style={{ textAlign: "left",
          pointerEvents: "none",
          opacity: "0.5",
          cursor: "none" }}
        >
          <i className="fas fa-tv" style={{ marginRight: "0.4rem" }}></i>
          Modo Sala de ventas
        </div>
        <div
          className="setting-dropdown-theme small"
          style={{ textAlign: "left", 
          pointerEvents: "none",
          opacity: "0.5",
          cursor: "none" }}
        >
          <i className="fas fa-expand" style={{ marginRight: "0.4rem" }}></i>
          Fullscreen
        </div> */}
        <div
          className="setting-dropdown-theme-logo"
          style={{
            textAlign: "center",
            marginTop:
              !window.functionIsPortrait() && window.functionIsMobileDevice()
                ? "0.375rem"
                : "1rem",
          }}
        >
          <img src="./UI/menu/logo_3ds.svg" alt="" width={25} />
        </div>
        <span
          style={{
            textAlign: "center",
            marginTop:
              !window.functionIsPortrait() && window.functionIsMobileDevice()
                ? "0.375rem"
                : "1rem",
          }}
        >
          {selectedLanguage?.is_main
                                  ? "Versión"
                                  : selectedLanguage?.language_code === "en" ? "Version" : "Versión"}  {version ? version : ""} - ® 2025
        </span>
      </div>
    </div>
  );
}
